import { Component, Input } from "@angular/core";
import { UserSession } from "./../../../models/user.model";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { MenuService } from "../../services/menuconfig.service";
import { SearchService } from "../../services/search.service";
import { BreadcrumbComponent } from "../breadcrumb/breadcrumb.component";
import { CartComponent } from "./cart/cart.component";
import { ProfileComponent } from "./profile/profile.component";
import { HidescrollnavService } from "../../services/utils/hidescrollnav.service";
import { SharedModule } from "../../shared.module";
import { SearchSmallHeaderComponent } from "./search-small/search-small-header.component";
import { CommonSvgIconComponent } from "../common-svg-icon/common-svg-icon.component";
import { SearchComponent } from "./search/search.component";
import { ThemeModeComponent } from "./theme-mode/theme-mode.component";
import { localStorageConstants } from "../../../consts/local_storage_constants";
import { NavService } from "../../services/nav.service";



@Component({
  selector: "app-header",
  imports: [SharedModule,
    FormsModule, RouterModule, CommonModule, SearchSmallHeaderComponent, CommonSvgIconComponent, SearchComponent,
    CartComponent, ProfileComponent, ThemeModeComponent,
  ],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})

export class HeaderComponent {

  @Input() publicClass: string;

  public isFlip: boolean = true;
  public isSearchOpen: boolean = false;
  public open: boolean = false;
  public userSession: UserSession;
  public isPortalLoggedIn: boolean = false;

  constructor(
    private router: Router,
public navService: NavService, 
    public hideScroolNavService: HidescrollnavService,
    public searchService: SearchService
  ) { }

  ngOnInit(): void {
    const userSessionRecover: any | null = localStorage.getItem(localStorageConstants.PORTAL_TOKEN);

    
    if (userSessionRecover && userSessionRecover.length > 0) {
      this.isPortalLoggedIn = true;
      this.userSession = userSessionRecover
     
    } else {
      this.isPortalLoggedIn = false;
    }
  }

  sidebarToggle() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }

  clickSignIn() {
    this.router.navigate(['/login']);
  }

  clickSignUp() {
    this.router.navigate(['/register']);
  }
}
